// extracted by mini-css-extract-plugin
module.exports = {"warning":"style_warning__1mfGc"};